/**
 * Muscle Grenade — Preferencias de perfil (sync con Fit Finder)
 */
(function () {
  'use strict';

  var GOAL_LABELS = {
    muscle: 'Ganar músculo',
    fat_loss: 'Definir / quemar grasa',
    energy: 'Energía y rendimiento',
    longevity: 'Longevidad y salud',
    wellness: 'Bienestar general',
    value: 'Mejor precio / packs',
    strength: 'Fuerza máxima',
    value: 'Mejor precio / packs'
  };

  var LEVEL_LABELS = {
    beginner: 'Principiante',
    intermediate: 'Intermedio',
    advanced: 'Avanzado'
  };

  var BUDGET_LABELS = {
    economy: 'Hasta $30.000',
    mid: '$30.000 – $60.000',
    premium: 'Más de $80.000',
    low: 'Hasta $40.000',
    high: 'Más de $80.000'
  };

  function storageKey() {
    if (window.MG_CUSTOMER && window.MG_CUSTOMER.id) {
      return 'mg-profile-prefs-' + window.MG_CUSTOMER.id;
    }
    return 'mg-profile-prefs-guest';
  }

  function normalizeGoal(goal) {
    if (!goal) return '';
    if (goal === 'mass' || goal === 'cut' || goal === 'health' || goal === 'strength') {
      var map = { mass: 'muscle', cut: 'fat_loss', health: 'longevity', strength: 'muscle' };
      return map[goal] || goal;
    }
    return goal;
  }

  function normalizeBudget(budget) {
    if (!budget) return '';
    if (budget === 'low') return 'economy';
    if (budget === 'high') return 'premium';
    return budget;
  }

  function load() {
    try {
      var raw = localStorage.getItem(storageKey());
      if (!raw) return null;
      var prefs = JSON.parse(raw);
      prefs.goal = normalizeGoal(prefs.goal);
      prefs.budget = normalizeBudget(prefs.budget);
      return prefs;
    } catch (e) {
      return null;
    }
  }

  function save(prefs) {
    var data = {
      goal: normalizeGoal(prefs.goal || ''),
      level: prefs.level || '',
      budget: normalizeBudget(prefs.budget || ''),
      notify_offers: !!prefs.notify_offers,
      updatedAt: new Date().toISOString(),
      source: prefs.source || 'profile'
    };
    try {
      localStorage.setItem(storageKey(), JSON.stringify(data));
      if (data.goal && data.level && data.budget) {
        localStorage.setItem('mg-finder-result', JSON.stringify({
          goal: data.goal,
          level: data.level,
          budget: data.budget
        }));
      }
    } catch (e) {}
    return data;
  }

  function fromFinderAnswers(answers) {
    if (!answers) return null;
    return save({
      goal: answers.goal,
      level: answers.level,
      budget: answers.budget,
      notify_offers: load()?.notify_offers,
      source: 'fit-finder'
    });
  }

  function toFinderAnswers(prefs) {
    prefs = prefs || load();
    if (!prefs) return null;
    return {
      goal: normalizeGoal(prefs.goal),
      level: prefs.level || '',
      budget: normalizeBudget(prefs.budget)
    };
  }

  function isComplete(prefs) {
    prefs = prefs || load();
    return !!(prefs && prefs.goal && prefs.level && prefs.budget);
  }

  function label(field, id) {
    if (field === 'goal') return GOAL_LABELS[id] || id;
    if (field === 'level') return LEVEL_LABELS[id] || id;
    if (field === 'budget') return BUDGET_LABELS[id] || id;
    return id;
  }

  function summary(prefs) {
    prefs = prefs || load();
    if (!prefs || !isComplete(prefs)) return null;
    return {
      goal: label('goal', prefs.goal),
      level: label('level', prefs.level),
      budget: label('budget', prefs.budget),
      updatedAt: prefs.updatedAt
    };
  }

  window.MGProfilePrefs = {
    load: load,
    save: save,
    fromFinderAnswers: fromFinderAnswers,
    toFinderAnswers: toFinderAnswers,
    isComplete: isComplete,
    label: label,
    summary: summary,
    storageKey: storageKey
  };
})();